module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_android_app_management.8b5d592dccf6e571e2434c975a044c83.png";